import * as React from "react";

function LockIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx={30} cy={30} r={30} fill="#fff" />
      <path
        d="M38.674 24.877H19.991a2.491 2.491 0 00-2.491 2.491v13.078a2.491 2.491 0 002.491 2.491h18.683a2.491 2.491 0 002.491-2.49V27.367a2.491 2.491 0 00-2.49-2.491z"
        stroke="#3C3C3C"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M32.24 32.45a2.909 2.909 0 10-4.359 2.49v1.869a1.451 1.451 0 002.902 0V34.94a2.902 2.902 0 001.457-2.492v0zM38.05 24.87V21.97a8.719 8.719 0 00-17.437 0v2.902h17.438z"
        stroke="#3C3C3C"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default LockIcon;
